import React from 'react'
import { reducer } from './reducer'
import { defaultState } from '@store/defaultReducerState.ts'
import { AppContext } from '@src/hooks/use-app-context'

// Funzione di inizializzazione per leggere lo stato da localStorage
const init = () => {
	const savedState = localStorage.getItem('appState') // Leggi tutto lo stato da localStorage

	//console.log('Valore nello storage:', savedState)

	let parsedState = defaultState

	if (savedState) {
		try {
			parsedState = JSON.parse(savedState) // Se esiste, decodifica l'oggetto salvato
		} catch (e) {
			console.error('Errore nel fare il parse dello stato da localStorage:', e)
		}
	}

	return parsedState // Restituisce lo stato salvato o quello di default
}

const AppContextProvider: React.FC<{ children: React.ReactNode }> = ({
	children,
}) => {
	const [state, dispatch] = React.useReducer(reducer, defaultState, init) // Usa l'inizializzazione personalizzata

	/* 
	useEffect(() => {

		localStorage.setItem('appState', JSON.stringify(state))
	}, [state]) // Ogni volta che `state` cambia
 */
	return (
		<AppContext.Provider value={{ state, dispatch }}>
			{children}
		</AppContext.Provider>
	)
}

export default AppContextProvider
